import React, { useState, useEffect } from "react"
import Table from "react-bootstrap/Table"
import { useSelector } from "react-redux"
import axios from "axios"
import Button from "react-bootstrap/Button"
import { useTranslation } from "react-i18next"

function UsersList() {
  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin
  const { t } = useTranslation()
  const apiUrl = process.env.REACT_APP_API_URL
  const [usersList, setUsersList] = useState([])
  const [confirmDelete, setConfirmDelete] = useState(null)

  const getConfig = () => ({
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${userInfo.access}`,
    },
  })

  useEffect(() => {
    async function fetchUsersList() {
      const { data } = await axios.get(`${apiUrl}/api/user/users-list/`, getConfig())
      setUsersList(data)
    }
    if (userInfo) fetchUsersList()
  }, [])

  const deactivateHandler = async (id) => {
    try {
      const { data } = await axios.post(
          `${apiUrl}/api/user/deactivate-user/${id}/`,
          {},
          getConfig()
      )
      setUsersList(data)
    } catch (error) {
      console.error("Error deactivating user:", error)
    }
  }

  const deleteUserHandler = async (id) => {
    try {
      const { data } = await axios.delete(
          `${apiUrl}/api/user/delete-user/${id}/`,
          getConfig()
      )
      setUsersList(data)
    } catch (error) {
      console.error("Error deleting user:", error)
    } finally {
      setConfirmDelete(null)
    }
  }

  return (
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <br />
            <h1>{t("usersLists.header")}</h1>
            <br />
            <Table striped bordered hover>
              <thead>
              <tr>
                <th>{t("newusers.Username")}</th>
                <th>{t("merchantsData.paymentDetail.email")}</th>
                <th>{t("usersLists.Options")}</th>
              </tr>
              </thead>
              <tbody>
              {usersList.map((user) => (
                  <tr key={user.id}>
                    <td>{user.username}</td>
                    <td>{user.email}</td>
                    <td>
                      <div className="users-list-btn">
                        <Button
                            variant="primary"
                            onClick={() => deactivateHandler(user.id)}
                        >
                          {t("usersLists.Deactivate")}
                        </Button>
                        <Button
                            variant="danger"
                            onClick={() => setConfirmDelete(user.id)}
                        >
                          {t("usersLists.Delete")}
                        </Button>
                      </div>
                    </td>
                  </tr>
              ))}
              </tbody>
            </Table>
          </div>
        </div>

        {confirmDelete && (
            <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
              <div className="modal-dialog modal-dialog-centered modal-sm">
                <div className="modal-content">
                  <div className="modal-header border-0 pb-0">
                    <h5 className="modal-title">
                      <i className="mdi mdi-alert-outline text-danger me-2"></i>
                      {t("usersLists.Delete")}
                    </h5>
                  </div>
                  <div className="modal-body pt-2">
                    <p className="mb-0 text-muted">
                      {t("usersLists.deleteConfirm", "Are you sure you want to delete this user?")}
                    </p>
                  </div>
                  <div className="modal-footer border-0 pt-0">
                    <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        onClick={() => setConfirmDelete(null)}
                    >
                      {t("validateRewards.Cancel")}
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => deleteUserHandler(confirmDelete)}
                    >
                      {t("usersLists.Delete")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
        )}
      </div>
  )
}

export default UsersList